import { api } from '#/apis';


export const clearCache = async (entrata_report_name, property_id) => {

    const { data } = await api.post(`/reports-cache/${entrata_report_name}/${property_id}`);

    return data;
};
